import { Tooltip } from 'antd';
import { getDocTypeIcon } from '../assets/docsTypes/docTypes';
import { getCurrencyRate } from '../data/vault.service';

export const VaultTooltip = ({ title, placement, children }) => {
    return (
        <Tooltip
            title={title.split('\n').map((line, i) => (
                <div key={i}>
                    {line}
                </div>
            ))}
            arrow
            placement={placement}
            overlayInnerStyle={{
                backgroundColor: '#000',
                color: '#fff',
                fontSize: '12px',
                fontWeight: '450',
                letterSpacing: '0.25px',
                padding: '12px',
                borderRadius: '8px',
            }}
        >
            {children}
        </Tooltip>
    )
}

export const getFileType = (fileName) => {
    const fileType = fileName.split('.').pop()?.toLowerCase();
    return getDocTypeIcon(fileType);
}

export const getFileSizeString = (sizeInBytes) => {
    const kb = 1024;
    const mb = (kb * kb);
    if (sizeInBytes >= mb) {
        return `${(sizeInBytes / (mb)).toFixed(1)}mb`;
    }
    return `${Math.round(sizeInBytes / kb)}kb`;
}

export const processedLLMResult = ({
    llmResult,
    metadataStore,
    currencyTable
}) => {
    const categoriesTitleObj = metadataStore.categoriesTitleObjForVault;
    const categoriesObj = metadataStore.categoriesObj;
    const items = (llmResult || []).map(item => {
        const lowerCaseCategory = item.category?.toLowerCase();
        const currency = item.currency || 'USD';
        const currencyRate = currencyTable[currency];
        const categoryId = item.categoryId ? item.categoryId : categoriesTitleObj[lowerCaseCategory]?.id || null;
        const classId = categoryId ? categoriesObj[categoryId]?.classId || null : null;
        const relevantClass = classId ? metadataStore.classes.find(cls => cls.id === classId) : null;
        return {
            ...item,
            currency,
            categoryId,
            classId,
            color: relevantClass?.color ?? '#FFFFFF',
            icon: relevantClass?.icon,
            usdValue: isNaN(item.amount) ? undefined : ((item.amount || 0) / (currencyRate || 1)),
            isFetchRate: !currencyRate
        };
    });

    return items;
};

export const calcCurrencies = async (currencyRates, items) => {
    if (!items) return currencyRates;

    // Extract unique currencies from items
    const itemCurrencies = [...new Set(items.map(item => item.currency))];

    // Filter currencies that are not already in currencyRates
    const currenciesToFetch = itemCurrencies.filter(currency => !(currency in currencyRates));

    // Fetch only missing currency rates
    const newCurrencyRates = await Promise.all(currenciesToFetch.map(async currency => {
        const rate = await getCurrentCurrencyRate(currency);
        return [currency, rate];
    }));

    return {
        ...currencyRates,
        ...Object.fromEntries(newCurrencyRates)
    };
}

export const getCurrentCurrencyRate = async (currency) => {
    if ("USD" === currency) return 1;

    let currencyRate = 0;
    if (!currency) return 0;
    try {
        const currencyRateObj = await getCurrencyRate(currency);
        if (currencyRateObj.statusCode) { } else {
            currencyRate = currencyRateObj.rate;
        }
    } catch (_e) {

    }

    return currencyRate;
}

export const calcTotals = ({ result, metadataStore }) => {
    const totalsObj = {
        assets: { count: 0, sum: 0 },
        liabilities: { count: 0, sum: 0 }
    };

    if (!result) return totalsObj;

    const assetsCategoriesObj = metadataStore.assetCategoriesObj;
    const liabilityCategoriesObj = metadataStore.liabilityCategoriesObj;
    const assets = result.filter(item => assetsCategoriesObj[item.categoryId]);
    const liabilities = result.filter(item => liabilityCategoriesObj[item.categoryId]);

    totalsObj.assets.count = assets.length;
    totalsObj.assets.sum = assets.reduce((acc, item) => (acc + (isNaN(item.usdValue) ? 0 : item.usdValue)), 0);;

    totalsObj.liabilities.count = liabilities.length;
    totalsObj.liabilities.sum = liabilities.reduce((acc, item) => (acc + (isNaN(item.usdValue) ? 0 : item.usdValue)), 0);

    return totalsObj;
}

export const getBulkEditFieldValue = (field, items) => {
    if (!items) return null;

    const fieldValue = items[0][field];
    return (items.every(item => item[field] === fieldValue) ? fieldValue : null);
}